var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Report__Entity" },
    [
      _c("Entity", {
        ref: "entity",
        attrs: {
          "entity-type": "VirtualContract",
          "entity-id": _vm.contractId,
          innerComponent: _vm.innerComponent,
          innerComponentTitle: "פרטי חוזה נקודתי",
          title: "חוזה נקודתי",
          "back-button-text": "רשימת רכבים",
          "back-button-url": "vehicles",
          widgets: _vm.widgets,
          preview: _vm.preview,
          "read-only": true,
          entityReady: _vm.entityReady,
          activities: []
        },
        scopedSlots: _vm._u([
          {
            key: "mandatory",
            fn: function() {
              return [
                _c(
                  "div",
                  {
                    staticClass: "Accident__Entity__Details__BaseDetails__Stage"
                  },
                  [
                    _c("span", { staticClass: "ltr" }, [_vm._v("שוכר:")]),
                    _c(
                      "span",
                      {
                        staticClass:
                          "Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold"
                      },
                      [_vm._v(_vm._s(_vm.Profile ? _vm.Profile.Name : ""))]
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "Accident__Entity__Details__BaseDetails__Stage"
                  },
                  [
                    _c("span", { staticClass: "ltr" }, [
                      _vm._v("חברת ליסינג:")
                    ]),
                    _c(
                      "span",
                      {
                        staticClass:
                          "Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.ContractOwner ? _vm.ContractOwner.Name : ""
                          )
                        )
                      ]
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "Accident__Entity__Details__BaseDetails__Stage"
                  },
                  [
                    _c("span", { staticClass: "ltr" }, [
                      _vm._v("תאריך תחילה:")
                    ]),
                    _c(
                      "span",
                      {
                        staticClass:
                          "Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold"
                      },
                      [
                        _c("FieldDateHourInline", {
                          attrs: { value: _vm.StartDate }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "Accident__Entity__Details__BaseDetails__Stage"
                  },
                  [
                    _c("span", { staticClass: "ltr" }, [_vm._v("תאריך סיום:")]),
                    _c(
                      "span",
                      {
                        staticClass:
                          "Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold"
                      },
                      [
                        _c("FieldDateHourInline", {
                          attrs: { value: _vm.EndDate }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "Accident__Entity__Details__BaseDetails__Stage"
                  },
                  [
                    _c("span", { staticClass: "ltr" }, [
                      _vm._v("תאריך עדכון:")
                    ]),
                    _c(
                      "span",
                      {
                        staticClass:
                          "Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold"
                      },
                      [
                        _c("FieldDateHourInline", {
                          attrs: { value: _vm.UpdateDate }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }